export default "/institutions/wells-fargo.svg";